<template>
  <section>
    <ChooseTmpl
      ref="chooseTmpl"
      title="选择年审费"
      :resultVal="resultVal"
      :isRadio="isRadio"
      :otherSearchData="otherSearchData"
      :searchBoxDataTmpl="searchBoxDataTmpl"
      :getListApi="getListApi"
      :tableTitle="tableTitle"
      :tableSelectTar="tableSelectTar"
      :showTableTitle="showTableTitle"
      @change="handleResultChange"
      :handleSearchData="handleSearchData"
      :customShow="customShow"
      :showName="showName"
      :clearable="clearable"
    >
      <section slot="tableSlot" slot-scope="scope">
        <section v-if="scope.column.property === 'certificatesInsuranceFee'">
          <span>{{scope.row[scope.column.property] / 100}}</span>
        </section>
        <section v-else>{{scope.row[scope.column.property]}}</section>
      </section>
    </ChooseTmpl>
  </section>
</template>

<script>
import {
  annualCostList,
} from 'api/cost';
import ChooseTmpl from 'components/choose/tmpl/tmpl.vue';
export default {
  components: {
    ChooseTmpl,
  },
  model: {
    prop: 'resultVal', // 父级传进来的值
    event: 'change',
  },
  props: {
    clearable: { // 清除按钮
      type: Boolean,
      default: false,
    },
    resultVal: {
      default: '',
    },
    isRadio: {
      type: Boolean,
      default: false,
    },
    otherSearchData: {
      type: Object,
      default: () => ({}),
    },
    customShow: { // 是否自定义展示结果
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      showName: 'plateNumber',
      tableSelectTar: 'id',
      searchBoxDataTmpl: {
        form: [
          { // 年审日期
            label: '年审日期',
            value: 'insuranceDate',
            type: 'date',
            default: [],
            placeholder: '请选择年审日期',
            attr: {
              type: 'daterange',
            },
          },
          {
            label: '年审类型',
            value: 'reviewType',
            type: 'select',
            placeholder: '请选择年审类型',
            options: [
              {
                label: '行驶证',
                value: 1,
              },
              {
                label: '营运证',
                value: 2,
              },
            ],
          },
          { // 车牌号码
            label: '车牌号码',
            value: 'plateNumber',
            type: 'input',
            placeholder: '请输入车牌号码',
          },
        ],
      },
      showTableTitle: [
        {
          prop: 'plateNumber',
          label: '车牌号码',
        },
      ],
      tableTitle: [
        {
          prop: 'certificatesInsuranceTypeName',
          label: '年审类型',
        },
        {
          prop: 'insuranceStartDate',
          label: '年审开始时间',
        },
        {
          prop: 'insuranceEndDate',
          label: '年审结束时间',
        },
        {
          prop: 'plateNumber',
          label: '车牌号',
        },
        {
          prop: 'orgName',
          label: '归属部门',
        },
        {
          prop: 'certificatesInsuranceFee',
          label: '年审费用',
        },
        {
          prop: 'createTime',
          label: '创建时间',
        },
      ],
    };
  },
  methods: {
    getListApi: annualCostList,
    handleResultChange (val) {
      this.$emit('change', val);
    },
    handleSearchData (searchBoxData) {
      if (searchBoxData.insuranceDate[0]) {
        searchBoxData.insuranceBeginDate = this.formatDate(searchBoxData.insuranceDate[0], 1);
        searchBoxData.insuranceEndDate = this.formatDate(searchBoxData.insuranceDate[1], 1);
      }
      delete searchBoxData.insuranceDate;
      return searchBoxData;
    },
    show () {
      this.$refs.chooseTmpl.show();
    },
  },
};
</script>

<style>

</style>
